import { getUserStore } from '@ai/common/src/store/UserStore';
import { tariffPlanStore } from '@store/TariffPlanStore';
import { useEffect, useMemo } from 'react';
import { tariffPlanPurchaseStore } from '@store/TariffPlanPurchaseStore';

export const useCurrentUserTariffPurchaseInfo = () => {
  const { currentUser, hasBalance } = getUserStore('platform');

  const {
    tariffPlanPurchases,
    loadList: loadPurchases,
    isListLoading: isPurchasesLoading,
  } = tariffPlanPurchaseStore;

  const { tariffPlans, loadList: loadPlans, isListLoading: isPlansLoading } = tariffPlanStore;

  useEffect(() => {
    if (!currentUser) return;

    loadPlans();
    loadPurchases();
  }, [loadPlans, currentUser]);

  const allPlansExpired = useMemo(() => {
    if (tariffPlanPurchases.active !== undefined && tariffPlanPurchases.expired !== undefined) {
      return !tariffPlanPurchases.active.length && !!tariffPlanPurchases.expired.length;
    }
    return undefined;
  }, [tariffPlanPurchases]);

  const neverBoughtPlan = useMemo(() => {
    if (tariffPlanPurchases.expired !== undefined && tariffPlanPurchases.active !== undefined) {
      return !tariffPlanPurchases.active.length && !tariffPlanPurchases.expired.length;
    }

    return undefined;
  }, [tariffPlanPurchases]);

  const unlimitedPlanExpired = useMemo(() => {
    const lastExpiredPurchase = tariffPlanPurchases.expired?.[0];
    const lastExpiredPlan = tariffPlans?.find(
      (plan) => plan.id === lastExpiredPurchase?.tariff_plan_id,
    );

    const isLastExpiredUnlimited =
      lastExpiredPlan?.is_unlimited &&
      lastExpiredPurchase &&
      lastExpiredPurchase.remaining_balance <= 0;

    // нет активных планов и последний истекший -- безлимитный, который истек по балансу (не по дате)
    // это нужно для вывода плашки о подозрительной активности
    return allPlansExpired && isLastExpiredUnlimited;
  }, [tariffPlanPurchases]);

  return {
    tariffPlanPurchases,
    tariffPlans,
    isPurchasesLoading,
    isPlansLoading,
    allPlansExpired,
    neverBoughtPlan,
    unlimitedPlanExpired,
    currentUser,
    hasBalance,
  };
};
